// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-05df7b66]{background-color:var(--v-grey4-base)}*[data-v-05df7b66] .v-input__slot{background-color:#fff!important;-webkit-box-shadow:0 0 15px rgba(63,63,63,.1803921568627451);box-shadow:0 0 15px rgba(63,63,63,.1803921568627451);height:55px;margin-top:-15px}", ""]);
// Exports
module.exports = exports;
